import React from 'react';
/* eslint-disable react/no-array-index-key */
import { Row } from '../types';
import { Slice } from './Slice';
import EventCell from './EventCell';
import { EDTPDFSettings } from '@teetsh/app/src/types/edt';
import { Classroom } from '@teetsh/app/src/types/classroom';
import { ClassroomsOrg } from '@teetsh/app/src/types/school';

interface Props {
  rows: Row[];
  settings: EDTPDFSettings;
  classrooms: Classroom[];
  classroomsOrg: ClassroomsOrg;
}

export default function EDTPrintBody({
  rows,
  settings,
  classrooms,
  classroomsOrg,
}: Props) {
  return (
    <tbody>
      {rows.map(row => (
        <tr style={{ fontSize: `${settings.fontSize}px` }} key={row.title}>
          <Slice height={row.height} title={row.title} />
          {row.cells.map((cell, index) => (
            <EventCell
              classrooms={classrooms}
              classroomsOrg={classroomsOrg}
              key={index}
              settings={settings}
              cell={cell}
            />
          ))}
        </tr>
      ))}
    </tbody>
  );
}
